import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FieldType } from 'src/app/settings/model/field-type';
import { ValueField } from 'src/app/settings/model/value-field';
import { ColumnFilterService } from 'src/app/shared/service/column-filter.service';

@Component({
  selector: 'app-column-filter',
  templateUrl: './column-filter.component.html',
  styleUrls: ['./column-filter.component.scss']
})
export class ColumnFilterComponent implements OnInit, OnDestroy {

  form: FormGroup;

  @Input() name: string;
  @Input() field: ValueField;

  icon: string;
  inputType: string;

  private unsubscribe$: Subject<boolean> = new Subject();

  constructor(private columnFilterService: ColumnFilterService) {
    this.form = new FormGroup({});
  }

  ngOnInit(): void {
    const savedValue = this.columnFilterService.getSavedValue(this.name);
    this.form.addControl(this.name, new FormControl(
      { value: savedValue, disabled: false }
    ));
    this.form.get(this.name).valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.columnFilterService.updateForm(this.name, this.form.controls[this.name]);
    });
    this.columnFilterService.clearAllFilters$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.form.reset();
    });
    // Kolumna słownikowa albo oflagowana listą wartości z danych dostaje kontrolkę z wyborem z
    // listy (a dla tej drugiej także przełącznik na filtr tekstowy) - typ pola nie ma tu już nic
    // do rzeczy, bo wartości i tak wybiera się z gotowej listy.
    if (this.field.type === FieldType.BOOLEAN) {
      this.inputType = 'boolean';
    } else if (this.field.options?.length > 0 || this.field.filterOptionsFromData) {
      this.inputType = 'value-list';
    } else if (this.field.type === FieldType.TIME) {
      this.inputType = 'time';
    } else {
      this.icon = 'search';
      this.inputType = 'search';
    }
    this.columnFilterService.registerForm(this.field, this.name, this.form.controls[this.name]);
    if (savedValue !== null) {
      this.columnFilterService.updateForm(this.name, this.form.controls[this.name]);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
    this.columnFilterService.unregisterForm(this.name);
  }

  onRightClick(event: MouseEvent): void {
    event.preventDefault();
    this.columnFilterService.clearColumnFilter(this.name);
  }

  toggleBoolean(value: boolean): void {
    const control = this.form.controls[this.name];
    control.setValue(control.value === value ? null : value);
  }
}
